import React, { memo } from 'react';

interface OptimizedImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  priority?: boolean;
  sizes?: string;
  srcSet?: string;
}

const OptimizedImage: React.FC<OptimizedImageProps> = memo(({
  src,
  alt,
  width,
  height,
  priority = false,
  loading,
  className,
  sizes,
  srcSet,
  ...props
}) => {
  // Determine loading strategy
  const loadingStrategy = priority ? 'eager' : (loading || 'lazy');
  const fetchPriority = priority ? 'high' : 'auto';

  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      loading={loadingStrategy}
      fetchPriority={fetchPriority}
      decoding="async"
      className={className}
      sizes={sizes}
      srcSet={srcSet}
      style={{ 
        contentVisibility: 'auto',
        maxWidth: '100%',
        height: '70px'
      }}
      {...props}
    />
  );
});

OptimizedImage.displayName = 'OptimizedImage';

export default OptimizedImage;

